import API_BASE from "../config/api";

export const getVehicleDetail = async (vehicleId) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Vehicle/Detail/?vehicle_id=${vehicleId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch vehicle detail");
  }

  return await response.json();
};